import { render, staticRenderFns } from "./ServicesCourses.vue?vue&type=template&id=5256d71e&scoped=true&"
import script from "./ServicesCourses.vue?vue&type=script&lang=js&"
export * from "./ServicesCourses.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCourses.vue?vue&type=style&index=0&id=5256d71e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5256d71e",
  null
  
)

export default component.exports